var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEritrea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.739 233.739C233.739 233.739 75.1305 437.056 74.9805 437.019C121.306 483.346 185.307 512 256 512C397.384 512 512 397.384 512 256L233.739 233.739Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.739 256C233.739 256 75.1305 74.945 74.9805 74.981C121.306 28.654 185.307 0 256 0C397.384 0 512 114.616 512 256H233.739Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9795 74.98C-24.9945 174.954 -24.9945 337.045 74.9795 437.02C74.9725 437.061 512 256 512 256L74.9795 74.98Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.565 150.261C84.4665 150.261 44.5225 190.206 44.5225 239.304V272.695C44.5225 321.794 84.4675 361.738 133.565 361.738C182.663 361.738 222.608 321.793 222.608 272.695V239.304C222.609 190.206 182.664 150.261 133.565 150.261ZM189.217 272.696C189.217 297.568 172.815 318.677 150.26 325.786V289.392L173.884 265.768L150.273 242.157L150.26 233.754V222.61H116.87V256L93.2625 279.607L116.87 303.214V325.787C94.3155 318.678 77.9135 297.569 77.9135 272.697V239.306C77.9135 208.619 102.879 183.654 133.565 183.654C164.251 183.654 189.217 208.62 189.217 239.306V272.696Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEritrea);
export default __webpack_public_path__ + "static/media/eritrea.9ce71d84101c04c88d62059c3c2a5351.svg";
export { ForwardRef as ReactComponent };